import React from 'react';
import {
  motion,
  AnimatePresence,
  MotionConfig,
  type HTMLMotionProps,
  type MotionConfigProps,
} from 'framer-motion';

export interface WithTransitions {
  isVisible: boolean;
  motionConfig?: MotionConfigProps;
  motionProps?: HTMLMotionProps<'div'>;
}

function withTransitions<T extends {}>(WrappedComponent: React.ComponentType<T>) {
  return (props: WithTransitions & T) => {
    const { isVisible, motionConfig, motionProps } = props;

    return (
      <MotionConfig {...motionConfig}>
        <AnimatePresence mode="popLayout">
          {isVisible && (
            <motion.div {...motionProps}>
              <WrappedComponent {...props} />
            </motion.div>
          )}
        </AnimatePresence>
      </MotionConfig>
    );
  };
}

export default withTransitions;
